module.exports = "https://cdn.dashboard.gifty.nl/5450/images/emoti-4.png?cdaa7c5128ee9fbe5b40a286e39a6df6";